<div class="ng-bento">
	<bento-combobox [(ngModel)]="selectedRow"
	[itemsObservable]="dataEmitter"
	(endOfScroll)="onEndOfScroll($event)"
	[readonly]="false"
	[options]="options">
	</bento-combobox>
</div>
